export enum TripType {
  BOB = "BOB",
  BOX = "BOX",
  INTERCONNECTION = "INTERCONNECTION"
}
